import { render, staticRenderFns } from "./UniCase.vue?vue&type=template&id=a6918aa8&scoped=true&"
import script from "./UniCase.vue?vue&type=script&lang=js&"
export * from "./UniCase.vue?vue&type=script&lang=js&"
import style0 from "./UniCase.vue?vue&type=style&index=0&id=a6918aa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6918aa8",
  null
  
)

export default component.exports